import React from 'react';
import EcoAllianceMap from '../EcoAllianceMap/EcoAllianceMap';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import {default as EcoAllianceBadge} from '../../../images/eco-alliance-badge.svg';
import './EcoAllianceHeader.scss';
import downloadEcoAllianceQrCertification from "../../../utils/downloadEcoAllianceQrCertification";

const EcoAllianceHeader = ({onClicked}) => {
  return ( <>
    <div className="noissue__eco-alliance__header">
        <CommunityImg src={EcoAllianceBadge} alt="eco-alliance badge" />
        <div className="noissue__eco-alliance__header__container">
          <div className="noissue__eco-alliance__header__container__heading">
            Our Eco-Alliance
          </div>
          <div className="noissue__eco-alliance__header__container__subheading">
            Our mission is to support and empower the shift to sustainable business practices by building a community that can be better together.
          </div>
          <button className="benefit-button" onClick={downloadEcoAllianceQrCertification}> Download Eco-A QR </button>
        </div>
        <EcoAllianceMap onClicked={(marker)=>onClicked(marker)} />
    </div>
  </>
  )
}

export default EcoAllianceHeader;
